
export default {
  name: 'BlogContentAnchorSection',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      strapiData: []
    }
  },
  computed: {
    hasTitleText() {
      return this.data?.BlogContent.some((item)=> item?.TitleText)
    },
    titleTextList() {
      const list  = this.data?.BlogContent.map(function(item, index) { 
        item.paragraphIndex = index
        return item 
      }).filter((item) => item.TitleText )
      return list
    }
  },
  methods: {
    jumpTo(theHash) {
      
      this.$nextTick(() => {
          
          console.debug('this.$route.hash...')
          console.debug(this.$route.hash)
          // const el = document.querySelector(this.$route.hash)
          const el = document.querySelector(theHash)
          console.debug('el...')
          console.debug(el)
          console.debug(el.offsetTop)
          console.debug(el.scrollTop)
          // el && el.scrollIntoView({behavior:'smooth',  block: "end", inline: "nearest"})
          // el.scrollTop = `scrollTop: ${scroller.scrollTop}`;
          // el.scrollTop = 500;
          const targetElement = el
          const navbar = document.querySelector('.nav-bar');
          const height = navbar.offsetHeight;
          let mobileExtra = 0
          if (navigator.userAgent.toLowerCase().match(/mobile/i)) { mobileExtra = 80}
          const scrollTopHeight = (targetElement.offsetTop) - (height + 20 + mobileExtra)
          console.debug('scrollTopHeight...')
          console.debug(scrollTopHeight)
          // $('html,body').animate({scrollTop: scrollTopHeight},1000);
    
          window.scrollTo({
            top: scrollTopHeight ,
            behavior: "smooth"
          });

        })
    }

  },
}
